import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "list", "item"];

  connect() {
    this.draggedItem = null;
    this.updateInput();
  }

  dragStart(e) {
    this.draggedItem = e.currentTarget;
    e.currentTarget.classList.add("opacity-50");
    e.dataTransfer.effectAllowed = "move";
  }

  dragOver(e) {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    const target = e.currentTarget;
    if (!this.draggedItem || target === this.draggedItem) return;
    const rect = target.getBoundingClientRect();
    const before = e.clientY < rect.top + rect.height / 2;
    if (before) {
      target.parentNode.insertBefore(this.draggedItem, target);
    } else {
      target.parentNode.insertBefore(this.draggedItem, target.nextSibling);
    }
  }

  drop(e) {
    e.preventDefault();
  }

  dragEnd(e) {
    e.currentTarget.classList.remove("opacity-50");
    this.draggedItem = null;
    this.updateInput();
  }

  updateInput() {
    const names = this.itemTargets.map((el) => el.dataset.name);
    this.inputTarget.value = names.join(" ");
  }
}
